import { render, staticRenderFns } from "./modal_propiedades.vue?vue&type=template&id=c3646c3e"
import script from "./modal_propiedades.vue?vue&type=script&lang=js"
export * from "./modal_propiedades.vue?vue&type=script&lang=js"
import style0 from "./modal_propiedades.vue?vue&type=style&index=0&id=c3646c3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports